import type { ReactNode } from 'react'
import { Button } from '@trafiflow/shared-ui'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
}

export function EmptyState({ icon, title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 border border-dashed rounded-lg border-fn-border bg-fn-muted"
    >
      <div
        className="p-3 rounded-full mb-3 bg-fn-hover"
      >
        {icon}
      </div>
      <p className="text-sm font-medium text-fn-text">
        {title}
      </p>
      <p className="text-xs mt-1 text-fn-text-muted">
        {description}
      </p>
      {actionLabel && onAction && (
        <Button variant="primary" className="mt-4 text-sm" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
